import { getStableHexColor } from '@/shared/utils';

// getStableHexColor 의 기본 학급 아바타 색상에 대응하는 배경 gradient tint.
// 보라색 아바타(#B179D2)의 경우 Figma 노드 31369:34960의
// #FFF → #FBF8FF → #F6F0FF → #FBF8FF → #FFF 그라데이션과 일치한다.
const CLASSROOM_GRADIENT_TINT_COLORS: Record<string, string> = {
  '#FF8D24': '#FFE5C3',
  '#00BA4A': '#D0FAD4',
  '#5278FF': '#CFEAFF',
  '#B179D2': '#DBC4FF',
  '#FF7BB7': '#FFD0FF',
};

const getClassroomGradientTintColor = (seed?: string) => {
  const accentColor = getStableHexColor(seed);
  return CLASSROOM_GRADIENT_TINT_COLORS[accentColor] ?? accentColor;
};

const hexToRgbString = (hexColor: string) =>
  `${parseInt(hexColor.slice(1, 3), 16)}, ${parseInt(
    hexColor.slice(3, 5),
    16,
  )}, ${parseInt(hexColor.slice(5, 7), 16)}`;

export const getClassroomGradientBackground = (seed?: string) => {
  const tintRgb = hexToRgbString(getClassroomGradientTintColor(seed));

  return `linear-gradient(180deg, #FFF 0%, rgba(${tintRgb}, 0.11) 20%, rgba(${tintRgb}, 0.25) 50%, rgba(${tintRgb}, 0.11) 80%, #FFF 100%)`;
};

// 클래스 상세 상단 히어로(Top bar) 그라데이션.
// Figma Top bar(909:29053): accent 색(0.9) → 밝은 tint(0.9) → 투명으로 페이드다운.
// 색은 학급 accent 팔레트를 그대로 따른다(브랜드 고정색 하드코딩 대신 클래스별 색 유지).
export const getClassroomHeroGradient = (seed?: string) => {
  const accentRgb = hexToRgbString(getStableHexColor(seed));
  const tintRgb = hexToRgbString(getClassroomGradientTintColor(seed));

  return `linear-gradient(180deg, rgba(${accentRgb}, 0.9) 38%, rgba(${tintRgb}, 0.9) 80%, rgba(255, 255, 255, 0) 100%)`;
};
